import { IGetDraftPaymentIntentResponse } from "../types";
import { EPaymentMethod } from "features/common";

export const mockGetDraftPaymentIntentResponse: IGetDraftPaymentIntentResponse =
  {
    result: {
      email: "test@test.com",
      paymentIntentSecret: "test_intent_23423",
      requestReference: "9fc638be-6d08-4100-bb16-ded0ca95f634",
      paymentMethod: EPaymentMethod.DirectDebit
    },
    isSuccess: true,
    message: null,
    validationIssues: null
  };
